import React from 'react';
import styled from 'styled-components';
import * as qs from 'qs';
import { useHistory } from 'react-router-dom';
import ProfileForm from '../components/forms/ProfileForm';
import TopHeader from '../components/TopHeader';
import BackButton from '../components/BackButton';
import { useTheme } from '../contexts/ThemeContext';

const Root = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  width: 100%;
  height: 100%;
`;

const ProfileView = ({ location }) => {
  const { s } = qs.parse(location.search, { ignoreQueryPrefix: true });
  const { theme, themeName } = useTheme();
  const history = useHistory();
  const isHelexia = themeName === 'helexia';
  const isGalp = themeName === 'galp';

  if (isGalp) {
    // The Galp profile screen (header + fields + fixed footer) is rendered
    // entirely by ProfileForm's own isGalp branch.
    return <ProfileForm />;
  }

  if (isHelexia) {
    return (
      <div style={{
        width: '100%',
        height: '100dvh',
        background: 'white',
        display: 'flex',
        flexDirection: 'column',
        boxSizing: 'border-box',
      }}
      >
        <TopHeader
          title="profile"
          userLogo
          showBackButton
          onBack={() => history.push('/home-no-vm')}
          backButtonColor={theme.titleColor}
          showShadow
        />
        <div style={{
          flex: 1,
          overflowY: 'auto',
          display: 'flex',
          flexDirection: 'column',
          padding: '20px 12px 66px',
        }}
        >
          <ProfileForm />
        </div>
      </div>
    );
  }

  return (
    <Root>
      <div style={{ flex: 1 }}>
        <TopHeader title="change_profile" userLogo />
        <ProfileForm />
        <BackButton screen={`/home${s ? `?s=${s}` : ''}`} />
      </div>
    </Root>
  );
};

export default ProfileView;
